import { Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import AuthRequired from '@/components/globals/AuthRequired';
import { useSentryTagsSetter } from '@/hooks/useSentryTagsSetter';
import { PostMessageAction, sendMessage } from '@/lib/postMessage';

import Blululululp from './Blululululp';
import Blululup from './Blululup';
import FaceCapture from './FaceCapture';
import MagicLinkPage from './MagicLinkPage';
import WizardPage from './WizardPage';
import '../lib/clarity';

export default function Pages() {
  useSentryTagsSetter();

  useEffect(() => {
    sendMessage(PostMessageAction.APP_LOAD, { loadedAt: new Date().toISOString() });
  }, []);

  return (
    <main className='bg-surface-disabled flex h-full w-full flex-col pb-6'>
      <Suspense>
        <Routes>
          <Route path='/magic/:uuid' element={<MagicLinkPage />} />

          <Route element={<AuthRequired />}>
            <Route path='/' element={<WizardPage />} />
            <Route path='/blululup' element={<Blululup />} />
            <Route path='/blululululp' element={<Blululululp />} />
          </Route>

          <Route path='/face-capture/:id' element={<FaceCapture />} />
          <Route path='*' element={<h1>404</h1>} />
        </Routes>
      </Suspense>
    </main>
  );
}
